export default __webpack_public_path__ + "static/tu-dc36fc1f1c2b069136571e69b403cf67.png";